import { isEqual } from 'lodash-es'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

import { DateRange } from 'components/meetings/filter_modal/components/date_range'
import { EventTypesSelect } from 'components/meetings/filter_modal/components/event_types_select'
import { useFilters } from 'hooks/scheduling/filters'

import { BaseFilterModal } from '../../shared/filters/base_filter_modal'
import { countNonDefaultFilters, getNonDefaultFilters, SUL_DEFAULT_FILTERS } from '../../shared/filters/helpers'

export const FilterModal = ({
  isOpen,
  onClose,
  setAppliedFiltersCount,
  identifierType = 'ID'
}) => {
  const dispatch = useDispatch()
  const { getFilterParams, applyFilterParams, isValidApplyParams } = useFilters()
  const filterParams = getFilterParams()
  const filterRef = useRef(filterParams)
  const [newFilterParams, setNewFilterParams] = useState(filterParams)
  const [showError, setShowError] = useState(false)

  useEffect(() => {
    if (!isValidApplyParams(newFilterParams)) {
      setShowError(true)
    } else {
      setShowError(false)
    }
  }, [newFilterParams, isValidApplyParams])

  useEffect(() => {
    if (!isEqual(filterParams, filterRef.current)) {
      filterRef.current = filterParams
      setNewFilterParams(filterParams)
      setAppliedFiltersCount(countNonDefaultFilters(filterParams))
    }
  }, [filterParams, setAppliedFiltersCount, filterRef])

  const onApply = () => {
    if (!showError) {
      dispatch(applyFilterParams(getNonDefaultFilters(newFilterParams)))
      setAppliedFiltersCount(countNonDefaultFilters(newFilterParams))
      onClose()
    }
  }

  const onClear = () => {
    setNewFilterParams({ ...SUL_DEFAULT_FILTERS })
  }

  if (!isOpen) return null

  return (
    <BaseFilterModal
      isOpen={isOpen}
      onClose={onClose}
      onApply={onApply}
      onClear={onClear}
    >
      <DateRange params={newFilterParams} onApply={setNewFilterParams} isSULFilter useColumnLayout />
      <EventTypesSelect params={newFilterParams} onApply={setNewFilterParams} identifierType={identifierType} useColumnLayout />
    </BaseFilterModal>
  )
}
